// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Scalars = require("../../../scalars/Scalars.bs.js");
let UTCDate = require("../../../reason/common/types/UTCDate.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let DevelopmentUnitSearchResultTimestamp_newDevelopmentUnit_graphql = require("../../../__generated__/DevelopmentUnitSearchResultTimestamp_newDevelopmentUnit_graphql.bs.js");

let convertFragment = DevelopmentUnitSearchResultTimestamp_newDevelopmentUnit_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, DevelopmentUnitSearchResultTimestamp_newDevelopmentUnit_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(DevelopmentUnitSearchResultTimestamp_newDevelopmentUnit_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, DevelopmentUnitSearchResultTimestamp_newDevelopmentUnit_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(DevelopmentUnitSearchResultTimestamp_newDevelopmentUnit_graphql.node, convertFragment, fRef);
}

let UnitFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function DevelopmentUnitSearchResultTimestamp(props) {
  let match = RescriptRelay_Fragment.useFragment(DevelopmentUnitSearchResultTimestamp_newDevelopmentUnit_graphql.node, convertFragment, props.unit);
  let broadcastDistance = UTCDate.formatDistanceFromNow(true, Scalars.DateTime.toUTC(match.onTanAt));
  return JsxRuntime.jsx("div", {
    children: `Broadcast ` + broadcastDistance + ` ago`,
    className: "text-sm text-gray-500"
  });
}

let make = DevelopmentUnitSearchResultTimestamp;

exports.UnitFragment = UnitFragment;
exports.make = make;
/* Scalars Not a pure module */
